import React, { useState, useRef, lazy, createElement } from 'react';
import html2canvas from 'html2canvas';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/8mGMBFzUfDBa2mdC9g2ZRk/AVY_LOGO.png';
const IMAGES = ['https://cdn.magicpatterns.com/uploads/8qaVzhbBqbgDxXRhc5QHSB/image-preview.png', 'https://cdn.magicpatterns.com/uploads/9yUoPf4537dLcbGSjQ7Tja/image-preview-2.png', 'https://cdn.magicpatterns.com/uploads/wQ7bieMDaPvr3SVrbf9f4k/pasted-image.jpg', 'https://cdn.magicpatterns.com/uploads/5xcQDiM7NauhJDmsf5Jb3v/3a552da3-adobestock_95260823-768x512-1.jpg', 'https://cdn.magicpatterns.com/uploads/svnnrQj7p8DkpJQ9wRofFL/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/nQp71aKkhBXXRt5oE8REja/pasted-image.webp', 'https://cdn.magicpatterns.com/uploads/uu2kLgEdwwNXt6sge5PQtw/pasted-image.jpg', 'https://cdn.magicpatterns.com/uploads/ef7t9HCDNnGeB55tWSTV7k/can-my-child-join-a-grammar-school-in-year-8-or-later(ysg5)_4.jpg', 'https://cdn.magicpatterns.com/uploads/d7Gxk2kYvifn7xfUGZ78Mj/personalized-tutor2.jpg', 'https://cdn.magicpatterns.com/uploads/x8NwvRMLRxUEzzu2EFEFHr/Mask-Group-1.png'];
const GeometricPattern = () => <svg viewBox="0 0 100 100" className="w-full h-full opacity-20" data-id="element-75">
    <rect x="0" y="0" width="50" height="50" fill="currentColor" data-id="element-76" />
    <circle cx="75" cy="25" r="25" fill="currentColor" data-id="element-77" />
    <path d="M 50 50 L 100 50 L 50 100 Z" fill="currentColor" data-id="element-78" />
    <circle cx="75" cy="75" r="15" fill="none" stroke="currentColor" strokeWidth="5" data-id="element-79" />
  </svg>;
export function BrandPage() {
  return <div className="min-h-screen bg-[#d9e2e8] p-2 md:p-4 font-sans selection:bg-accent selection:text-white" data-id="element-80">
      <div className="main-container max-w-[1600px] mx-auto bg-card rounded-[1.5rem] md:rounded-[2rem] border border-black/5 shadow-sm min-h-[calc(100vh-2rem)] flex flex-col" data-id="element-81">
        <Navigation activePath="/" data-id="element-82" />

        <main className="flex-1 px-4 md:px-16 py-6 md:py-8 space-y-16 md:space-y-32" data-id="element-83">
          {/* Hero Section */}
          <section className="relative flex flex-col justify-center pt-4 md:pt-16 pb-8 md:pb-24 space-y-8 md:space-y-24" data-id="element-84">
            <div className="max-w-6xl" data-id="element-85">
              <h1 className="text-[clamp(2rem,10vw,8rem)] font-semibold leading-[0.95] md:leading-[0.9] tracking-[-0.04em] text-ink" data-id="element-86">
                Your brand <br className="hidden sm:block" data-id="element-87" />
                should be <br className="hidden sm:block" data-id="element-88" />
                as good as <br className="hidden sm:block" data-id="element-89" />
                your business
                <span className="text-accent inline-block w-[0.15em] h-[0.15em] rounded-full ml-[0.05em] mb-[0.1em]" data-id="element-90" />
              </h1>
              <div className="mt-6 max-w-sm text-base md:text-lg leading-[1.6] md:leading-[1.7] text-ink/70 font-medium" data-id="element-91">
                Most businesses are further ahead than their brand suggests. We
                make sure the world sees it.
              </div>
            </div>

            <div className="flex justify-center w-full" data-id="element-92"></div>
          </section>

          {/* Photography Section */}
          <section id="photography" className="space-y-6 md:space-y-12" data-id="element-93">
            <div className="flex items-center justify-between" data-id="element-94">
              <div className="space-y-1" data-id="element-95">
                <h2 className="text-xl md:text-2xl font-bold tracking-tight" data-id="element-96">
                  Photography Style
                </h2>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-start" data-id="element-97">
              <div className="md:col-span-2 bg-white rounded-[1rem] p-6 md:p-14 border border-[#2b2b2b]/5 flex flex-col justify-between relative overflow-hidden shadow-sm min-h-[250px] md:min-h-[400px]" data-id="element-98">
                <div className="absolute top-0 right-0 w-24 h-24 md:w-32 md:h-32 opacity-10" data-id="element-99">
                  <GeometricPattern data-id="element-100" />
                </div>
                <span className="font-display text-4xl md:text-6xl opacity-10" data-id="element-101">
                  01
                </span>
                <div className="space-y-3 md:space-y-4 relative z-10" data-id="element-102">
                  <span className="bg-[#ef3e23] text-white px-3 py-1 text-[10px] font-bold uppercase tracking-widest rounded-full w-fit" data-id="element-103">
                    Client Brief
                  </span>
                  <h2 className="font-display text-2xl md:text-6xl tracking-[-0.02em] leading-tight" data-id="element-104">
                    Headway Tuition <br data-id="element-105" />
                    Photography
                  </h2>
                  <p className="text-xs md:text-sm font-medium text-[#2b2b2b]/60 leading-[1.6] max-w-2xl" data-id="element-106">
                    Photos for Headway Tuition's 11+ guide and website showing
                    calm, confident, mindful children: focused at the kitchen
                    table with a relaxed, supportive parent, and playful while
                    learning through simple games and puzzles, always with
                    genuine smiles and no exam panic. The playfulness, the
                    games, the activities.
                  </p>
                </div>
              </div>

              <div className="aspect-square rounded-[1rem] overflow-hidden border border-[#2b2b2b]/10 shadow-sm relative group" data-id="element-107">
                <img src="https://cdn.magicpatterns.com/uploads/svnnrQj7p8DkpJQ9wRofFL/pasted-image.png" alt="Style reference" className="w-full h-full object-cover" loading="lazy" data-id="element-108" />
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4" data-id="element-109">
              {IMAGES.map((src, i) => <div key={i} className="aspect-square rounded-[0.75rem] md:rounded-[1rem] overflow-hidden border border-[#2b2b2b]/10 bg-white" data-id="element-110">
                  <img src={src} alt={`Style ${i}`} className="w-full h-full object-cover" loading="lazy" data-id="element-111" />
                </div>)}
            </div>
          </section>

          {/* Format Section */}
          <section className="space-y-6 md:space-y-12" data-id="element-112">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 items-start" data-id="element-113">
              <div className="bg-[#2b2b2b] text-white rounded-[1rem] md:rounded-[1.5rem] p-6 md:p-14 flex flex-col justify-between aspect-square relative overflow-hidden shadow-sm" data-id="element-114">
                <div className="absolute top-0 right-0 w-24 h-24 md:w-32 md:h-32 opacity-10" data-id="element-115">
                  <GeometricPattern data-id="element-116" />
                </div>
                <span className="font-display text-4xl md:text-6xl opacity-10" data-id="element-117">
                  02
                </span>
                <div className="space-y-3 md:space-y-4 relative z-10" data-id="element-118">
                  <h2 className="font-display text-2xl md:text-6xl tracking-[-0.02em] leading-tight" data-id="element-119">
                    Format & <br data-id="element-120" />
                    Composition
                  </h2>
                  <p className="text-base md:text-lg text-white/60 font-medium" data-id="element-121">
                    Every setup shot in both landscape and portrait with clean
                    space for text overlays.
                  </p>
                </div>
              </div>

              <div className="space-y-4 md:space-y-6" data-id="element-122">
                <div className="aspect-[16/9] md:aspect-[21/9] rounded-[1rem] overflow-hidden border border-black/10 relative bg-white group" data-id="element-123">
                  <img src={IMAGES[2]} alt="Landscape" className="w-full h-full object-cover" loading="lazy" data-id="element-124" />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors" data-id="element-125" />
                  <div className="absolute inset-0 flex items-center p-6 md:p-8" data-id="element-126">
                    <div className="max-w-xs space-y-2 relative z-10" data-id="element-127">
                      <div className="h-1 w-8 md:w-12 bg-[#d2ff46] shadow-sm" data-id="element-128" />
                      <h4 className="font-display text-xl md:text-2xl text-white drop-shadow-md" data-id="element-129">
                        Hero Layout
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="aspect-[4/5] rounded-[1rem] overflow-hidden border border-black/10 relative bg-white group" data-id="element-130">
                  <img src={IMAGES[3]} alt="Portrait" className="w-full h-full object-cover" loading="lazy" data-id="element-131" />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors" data-id="element-132" />
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer data-id="element-133" />
      </div>
    </div>;
}